export default __webpack_public_path__ + "static/media/vongole3.2e993233.jpg";